/* Dostepnosc w magazynach (snippets/magazyny-stan.liquid): strona produktu
   (lista magazynow z „na stanie / brak”) i szuflada koszyka (jedna linia
   „Na stanie: ...”). Dane z uslugi dostawy: GET <usluga>/stany?warianty=id,id
   -> { magazyny: [{ uchwyt, miasto, odbior }], warianty: { id: { uchwyt: bool } | null } }.
   Szuflada przerysowuje sie po kazdej zmianie koszyka, wiec nowe elementy
   lapie MutationObserver; odpowiedzi trzymamy w pamieci strony po id
   wariantu. Awaria uslugi = elementy zostaja schowane. */
(function () {
  if (window.dizzStany) return;

  // Adres uslugi z ustawien motywu (atrybut znacznika skryptu w layoucie) -
  // potrzebny tez bez zadnego elementu na stronie (krok 2 koszyka).
  const uslugaZUstawien = (document.currentScript && document.currentScript.dataset.service) || '';

  // id wariantu -> Promise<{ magazyny, stan } | null>; stan null = wariant bez
  // limitu (niesledzony albo na minusie), caly wynik null = usluga nie odpowiedziala.
  const pamiec = new Map();

  const pobierz = (usluga, ids) => {
    const brakujace = ids.filter((id) => !pamiec.has(id));
    if (brakujace.length) {
      const zadanie = fetch(`${usluga.replace(/\/$/, '')}/stany?warianty=${brakujace.join(',')}`)
        .then((r) => (r.ok ? r.json() : null))
        .catch(() => null);
      brakujace.forEach((id) => {
        const wynik = zadanie.then((dane) => {
          if (!dane || !dane.warianty || !(id in dane.warianty)) {
            pamiec.delete(id); // awaria nie zostaje w pamieci na cala odslone
            return null;
          }
          return { magazyny: dane.magazyny, stan: dane.warianty[id] };
        });
        pamiec.set(id, wynik);
      });
    }
    return Promise.all(ids.map((id) => pamiec.get(id)));
  };

  const narysuj = (el, wynik) => {
    if (!wynik || !wynik.stan || !wynik.magazyny.length) {
      el.hidden = true;
      return;
    }
    const { magazyny, stan } = wynik;
    const dopisek = (m) => (m.odbior ? '' : ` (${el.dataset.labelOnline})`);
    if (el.hasAttribute('data-wh-line')) {
      const sa = magazyny.filter((m) => stan[m.uchwyt]);
      el.textContent = sa.length ? el.dataset.labelLine.replace('__LISTA__', sa.map((m) => m.miasto + dopisek(m)).join(', ')) : '';
      el.hidden = !sa.length;
      return;
    }
    const lista = el.querySelector('[data-wh-list]');
    lista.replaceChildren(
      ...magazyny.map((m) => {
        const li = document.createElement('li');
        li.className = `wh-stock__item ${stan[m.uchwyt] ? 'is-jest' : 'is-brak'}`;
        const nazwa = document.createElement('span');
        nazwa.className = 'wh-stock__name';
        nazwa.textContent = m.miasto;
        if (!m.odbior) {
          const uwaga = document.createElement('span');
          uwaga.className = 'wh-stock__note';
          uwaga.textContent = el.dataset.labelOnline;
          nazwa.append(' ', uwaga);
        }
        const stanEl = document.createElement('span');
        stanEl.className = 'wh-stock__state';
        stanEl.textContent = stan[m.uchwyt] ? el.dataset.labelYes : el.dataset.labelNo;
        li.append(nazwa, stanEl);
        return li;
      }),
    );
    el.hidden = false;
  };

  const odswiez = (root) => {
    const elementy = [...(root || document).querySelectorAll('[data-wh-stock]')].filter((el) => /^\d+$/.test(el.dataset.variant || ''));
    if (!elementy.length) return;
    const usluga = elementy[0].dataset.service;
    const ids = [...new Set(elementy.map((el) => el.dataset.variant))];
    pobierz(usluga, ids).then(() => {
      elementy.forEach((el) => pamiec.get(el.dataset.variant).then((w) => narysuj(el, w)));
    });
  };

  // Zmiana wariantu na stronie produktu: theme.js przepisuje wybor na ukryte
  // pole id formularza (bez zdarzenia), wiec czytamy je po zmianie selecta.
  document.addEventListener('change', (e) => {
    if (!e.target.closest('[data-variant-picker]')) return;
    const pole = e.target.closest('form')?.querySelector('[data-variant-id]');
    const blok = document.querySelector('.wh-stock[data-wh-stock]');
    if (!pole || !blok || !pole.value || blok.dataset.variant === pole.value) return;
    blok.dataset.variant = pole.value;
    odswiez(blok.parentElement);
  });

  new MutationObserver((zmiany) => {
    if (zmiany.some((z) => [...z.addedNodes].some((n) => n.nodeType === 1 && (n.matches('[data-wh-stock]') || n.querySelector('[data-wh-stock]'))))) {
      odswiez();
    }
  }).observe(document.documentElement, { childList: true, subtree: true });

  /* Dla kroku 2 koszyka (assets/delivery-check.js): stany kilku wariantow
     naraz. Oddaje tablice { magazyny, stan } w kolejnosci ids albo null, gdy
     usluga nie odpowiedziala dla ktoregokolwiek. */
  const stany = (ids) => {
    if (!uslugaZUstawien || !ids.length) return Promise.resolve(null);
    return pobierz(uslugaZUstawien, ids.map(String)).then((wyniki) => (wyniki.some((w) => !w) ? null : wyniki));
  };

  window.dizzStany = { odswiez, stany };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => odswiez());
  else odswiez();
})();
